import {POST_SURVEY_RESPONSES} from './types';

export const postSurveyResponses = (responses, patientId, surveyId, token) => {
  return {
    type: POST_SURVEY_RESPONSES,
    payload: {responses, surveyId, patientId, token}
  };
};
